import { useEffect, useState } from 'react';

/**
 * Dialogo aberto mais recente da pagina, ou nulo.
 *
 * O Modal e a Drawer abrem com showModal(): o dialogo vai para a camada superior do
 * navegador, e todo o resto da pagina fica inerte e atras do fundo escuro. O botao do
 * Assistente, fixo no canto e fora do dialogo, sumia atras do fundo e nao recebia
 * clique. Com este gancho o Assistente se desenha dentro do dialogo de cima, e por
 * isso continua visivel e clicavel com qualquer janela aberta.
 *
 * A pagina e observada com MutationObserver: um dialogo aberto ou fechado (o atributo
 * open) e um dialogo montado ou desmontado mudam o resultado. A pilha guarda a ordem
 * de abertura, porque a ordem no documento nao diz qual dialogo esta por cima: a
 * confirmacao aberta de dentro de uma gaveta vem depois dela, mesmo que a gaveta
 * esteja mais abaixo no documento.
 *
 * Todo dialogo aberto conta, sem conferir se e modal: o sistema so abre dialogo modal,
 * e um dialogo nao modal tambem receberia o Assistente sem prejuizo.
 */
export function useDialogoAberto(): HTMLDialogElement | null {
  const [dialogo, setDialogo] = useState<HTMLDialogElement | null>(null);

  useEffect(() => {
    let pilha: HTMLDialogElement[] = [];

    function atualizar() {
      const abertos = Array.from(document.querySelectorAll('dialog[open]')).filter(
        (elemento): elemento is HTMLDialogElement =>
          elemento instanceof HTMLDialogElement,
      );
      pilha = pilha.filter((aberto) => abertos.includes(aberto));
      for (const aberto of abertos) {
        if (!pilha.includes(aberto)) pilha.push(aberto);
      }
      setDialogo(pilha.at(-1) ?? null);
    }

    atualizar();
    const observador = new MutationObserver(atualizar);
    observador.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['open'],
    });
    return () => observador.disconnect();
  }, []);

  return dialogo;
}
